<template>
  <div class="w-full h-fit mb-4">
    <div class="mx-auto mt-2 md:w-[400px] md:spaced-divs">
      <div>
        Card Number
        <div>
          <input
            ref="cardNumber"
            type="text"
            maxlength="19"
            @input="validateField($event, cardNumber, 'cardNumber')"
            @blur="validateLength(cardNumber, 'cardNumber', 19)"
          />
        </div>
        <span v-if="warnings.cardNumber">Invalid Card Number</span>
      </div>
      <div class="mt-2 flex justify-center">
        <div>
          Expiration
          <div>
            <input
              ref="expiration"
              type="text"
              placeholder="MM/YYYY"
              class="w-28 mr-2"
              maxlength="7"
              @input="validateField($event, expiration, 'expiration')"
              @blur="validateLength(expiration, 'expiration', 7)"
            />
          </div>
          <span v-if="warnings.expiration">Invalid Expiration</span>
        </div>
        <div>
          CVC
          <div>
            <input
              ref="cvc"
              type="text"
              class="w-16"
              maxlength="4"
              @input="validateField($event, cvc, 'cvc')"
            />
          </div>
          <span v-if="warnings.cvc">Invalid CVC</span>
        </div>
      </div>
      <div class="w-full mt-2">
        Name On Card
        <input
          class="w-[98%]"
          ref="nameOnCard"
          type="text"
          maxlength="50"
          @input="validateField($event, nameOnCard, 'nameOnCard')"
        />
        <span v-if="warnings.nameOnCard">Invalid Name</span>
      </div>
      <div class="w-full mt-2">
        Billing Address
        <input
          class="w-[98%]"
          ref="billingAddress"
          type="text"
          maxlength="100"
          @input="validateField($event, billingAddress, 'billingAddress')"
        />
        <span v-if="warnings.billingAddress">Invalid Address</span>
      </div>
      <div class="w-full">
        <div class="mt-2 mx-auto w-[98%] flex">
          <div class="w-[45%]">
            City
            <input
              class="w-full"
              ref="city"
              type="text"
              maxlength="50"
              @input="validateField($event, city, 'city')"
            />
            <span v-if="warnings.city">Invalid City</span>
          </div>
          <div class="ml-2 w-[50%]">
            State
            <select ref="state">
              <option value="">N/A</option>
              <option value="AK">Alaska</option>
              <option value="AL">Alabama</option>
              <option value="AR">Arkansas</option>
              <option value="AZ">Arizona</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DC">District of Columbia</option>
              <option value="DE">Delaware</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="IA">Iowa</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="MA">Massachusetts</option>
              <option value="MD">Maryland</option>
              <option value="ME">Maine</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MO">Missouri</option>
              <option value="MS">Mississippi</option>
              <option value="MT">Montana</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="NE">Nebraska</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NV">Nevada</option>
              <option value="NY">New York</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="PR">Puerto Rico</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VA">Virginia</option>
              <option value="VT">Vermont</option>
              <option value="WA">Washington</option>
              <option value="WI">Wisconsin</option>
              <option value="WV">West Virginia</option>
              <option value="WY">Wyoming</option>
            </select>
          </div>
        </div>
      </div>
      <div class="w-full">
        Zip Code
        <div>
          <input
            ref="zip"
            type="text"
            class="w-20"
            placeholder="12345"
            maxlength="5"
            @input="validateField($event, zip, 'zip', 5)"
            @blur="validateLength(zip, 'zip', 5)"
          />
        </div>
        <span v-if="warnings.zip">Invalid Zip</span>
      </div>
      <div class="justify-center w-full">
        <div v-if="error" class="text-red-500" v-html="error"></div>
        <button
          class="my-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          @click="handlePayment"
        >
          <div v-if="loading">
            <PulseLoader />
          </div>
          <div v-else-if="captured">Payment Accepted</div>
          <div v-else>Pay Invoice</div>
        </button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive } from "vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { useReview } from "@/stores";
const reviewStore = useReview();

const error = ref("");
const loading = ref(false);
const captured = ref(false);

const warnings = reactive({
  cardNumber: false,
  expiration: false,
  cvc: false,
  nameOnCard: false,
  billingAddress: false,
  city: false,
  state: false,
  zip: false,
});

const cardNumber = ref("");
const expiration = ref("");
const cvc = ref("");
const nameOnCard = ref("");
const billingAddress = ref("");
const city = ref("");
const state = ref("");
const zip = ref("");

const numberFields = ["cvc", "zip"];

function validateField(event, fieldRef, refName) {
  let field = fieldRef.value;
  if (numberFields.includes(refName)) {
    fieldRef.value = fieldRef.value.replace(/\D/g, "");
  }

  if (refName === "cardNumber") {
    // Remove all characters except digits
    fieldRef.value = fieldRef.value.replace(/\D/g, "");
    field = fieldRef.value;

    // Insert dashes at the appropriate spots
    fieldRef.value = field.replace(/(\d{4})/g, "$1-").replace(/-$/, "");
  }

  if (refName === "expiration") {
    // Remove all characters except digits and '/'
    fieldRef.value = fieldRef.value.replace(/[^0-9/]/g, "");
    field = fieldRef.value;

    // Insert a '/' after MM if not present
    if (
      field.length === 2 &&
      !field.includes("/") &&
      event.inputType !== "deleteContentBackward"
    ) {
      fieldRef.value = field + "/";
      field = fieldRef.value; // Update the field variable
    }
  }
}

function validateLength(field, refName, maxLength) {
  if (field && field.value.length !== maxLength) {
    warnings[refName] = true;
  } else {
    warnings[refName] = false;
  }
}

const handlePayment = async () => {
  // prefill for testing
  if (import.meta.env.VITE_APP === "development") {
    cardNumber.value.value = "4242424242424242";
    expiration.value.value = "12/2030";
    cvc.value.value = "123";
    nameOnCard.value.value = "Test User";
    billingAddress.value.value = "123 Test St";
    city.value.value = "Test City";
    state.value.value = "CA";
    zip.value.value = "12345";
  }

  //TODO: error handling here so we don't rely on qb
  error.value = "";
  loading.value = true;
  const data = {
    cardNumber: cardNumber.value.value,
    expiration: expiration.value.value,
    cvc: cvc.value.value,
    nameOnCard: nameOnCard.value.value,
    billingAddress: billingAddress.value.value,
    city: city.value.value,
    state: state.value.value,
    zip: zip.value.value,
  };

  const response = await reviewStore.cardCharge(data);
  if (response && response.data.error) {
    error.value = response.data.error;
    loading.value = false;
    return;
  }
  if (response.data.data.status === "CAPTURED") {
    captured.value = true;
    setTimeout(() => {
      reviewStore.invoiceStatus = "paid";
      reviewStore.currentComponent = "ExperienceReview";
    }, 1000);
  }
};
</script>
<style scoped>
input,
select {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 12px;
  box-sizing: border-box;
}

.spaced-divs > div {
  margin: 8px 8px;
}

input::placeholder {
  font-style: italic;
}

span {
  color: red;
  font-size: 12px;
}
</style>
